import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {ServiceTimeRequestsService} from "../../services/service-time-requests.service";

export class PricePlanCreateServiceTimeEventDialogViewComponent implements IController {
  programId: any;
  days: any;
  currentDay: any;
  query: any;

  public event: any;
  public dayOfWeekOptions: any;
  public config: any;
  public isLoading: boolean;
  public startTime: any;
  public endTime: any;
  public daysOfWeek: any;
  public dateSelectOptions: any;
  public isTimeSelectionCurrect: any;
  public cancel: Function;

  constructor(private $mdDialog, private pricePlanConstant, private $stateParams, private serviceTimeRequestsService: ServiceTimeRequestsService, private splitService) {
    this.config = angular.copy(this.pricePlanConstant.serviceTime);
  }

  $onInit() {
    this.event = {
      slot: {
        //The following properties will be set via the UI : 'commission', 'priceExtra', 'priceFactor'
        from: 0,
        to: 1,
        enabled: this.config.createEventDefaults.isSlotEnabled
      }
    };

    this.dayOfWeekOptions = this.config.events.dayOfWeek;
    this.daysOfWeek = [this.config.events.dayOfWeek[0]];
    this.isLoading = false;
    this.isTimeSelectionCurrect = true;

    this.startTime = this.config.createEventDefaults.startTime;
    this.endTime = this.config.createEventDefaults.endTime;

    this.createDateSelectOptions();
    this.changeEventColors();
    this.cancel = this.$mdDialog.cancel;

  }

  ok() {
    this.event.slot.from = this.updateSlotTime(this.startTime);
    this.event.slot.to = this.updateSlotTime(this.endTime);

    const days = this.getDays(this.daysOfWeek),
      daysCopy = angular.copy(days);

    _.forEach(daysCopy, (day) => {
      day.dayChunks.push(this.event.slot);
    })

    this.isLoading = true;
    this.query.zoneId = this.splitService.getTimeZone();

    this.serviceTimeRequestsService.updateCreateServiceTime(this.programId, daysCopy, this.query).then(
      (serviceTime) => {
        this.$mdDialog.hide({
          serviceTime: serviceTime,
          updatedDays: this.getDays(this.daysOfWeek, serviceTime)
        });

      }
    ).catch(error => this.$mdDialog.cancel(error));

  }

  getDay(dayOfWeek, serviceTime) {
    return _.find(serviceTime || this.days, (day) => {
      return _.isEqual(dayOfWeek, day.dayOfWeek);
    });
  }

  getDays(daysOfWeek, serviceTime?) {

    return _.filter(serviceTime || this.days, (day) => {
      return _.includes(daysOfWeek, day.dayOfWeek)
    })

  }

  updateSlotTime(time) {
    var HOUR = 60,
      minutes = time.minute > 0 ? HOUR / time.minute : time.minute,
      factored = minutes > 0 ? 1 / minutes : minutes;

    return time.hour + factored;
  }

  createDateSelectOptions() {
    // create options for time select boxes (this will be removed in favor of mdDatetime picker when it becomes available).
    this.dateSelectOptions = {
      hours: [],
      minutes: []
    };

    const steps = this.pricePlanConstant.serviceTime.steps;

    //Hours
    for (let hour = 0; hour <= 23; hour = hour + steps.hour) {
      this.dateSelectOptions.hours.push(hour);
    }

    //Minutes
    for (let minute = 0; minute <= 59; minute = minute + steps.minute) {
      this.dateSelectOptions.minutes.push(minute);
    }
  }

  changeEventColors() {
    const state = this.event.slot.enabled ? this.config.events.states[3] : this.config.events.states[2],
      colorScheme = this.serviceTimeRequestsService.getEventColorScheme(false, state);
    _.merge(this.event, colorScheme);
  }

  timeValidationCheck() {
    if (this.startTime.hour >= this.endTime.hour) {
      this.isTimeSelectionCurrect = this.startTime.minute < this.endTime.minute;
    } else {
      this.isTimeSelectionCurrect = true;
    }
  }


}

angular
  .module('bringoz.admin.pricePlan')
  .component('pricePlanCreateServiceTimeEventDialogView', {
    bindings: {
      programId: '<',
      days: '<',
      currentDay: '<',
      query: '<'
    },
    template: require('./price-plan-create-service-time-event-dialog-view.html').default,
    controller: PricePlanCreateServiceTimeEventDialogViewComponent

  });
